<template>
    <v-container fluid class="pa-3" v-if="sessionActive">

        <material-header title="Locales"
                         :loading="localesLoading"
                         info="Internationalization options"
                         help="locales"
                         icon="mdi-city">

            <template slot="buttons">
                <v-tooltip top color="primary">
                    <template v-slot:activator="{ on }">
                        <v-btn v-on="on" icon text @click="reloadClicked">
                            <v-icon>mdi-refresh</v-icon>
                        </v-btn>
                    </template>

                    <span>Reload view</span>
                </v-tooltip>

            </template>
        </material-header>

        <v-card tile flat>
            <v-card-text class="pt-1">
                <v-container fluid class="pa-0">
                    <v-row no-gutters>
                        <v-spacer></v-spacer>
                        <v-col cols="12" xl="2" lg="4" md="6" sm="12" xs="12">
                            <v-text-field
                                    prepend-icon="mdi-magnify"
                                    label="Search"
                                    hint="Type in country, language or code"
                                    v-model="searchTerm"
                                    solo
                                    dense
                                    background-color="grey darken-2"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
        </v-card>

        <v-row dense class="pt-1">
            <v-col cols="12" xl="2" lg="3" md="4" sm="6" xs="12" class="pa-0" v-for="locale in localesList" :key="locale.id">
                <locale :data="locale"
                        :active="!!panelLocalesList.find((panelLocal) => locale.id === panelLocal.id)"
                        toggleable
                        @enable="localeEnabled"
                        @disable="localeDisabled"
                ></locale>
            </v-col>
            <json v-if="debug" :data="localesList"></json>
        </v-row>

    </v-container>
</template>

<script>

    import Json from 'vue-json-pretty';
    import Store from '../store';
    import {mapActions, mapGetters, mapState} from 'vuex';
    import activeSessionChecker from '../../../components/mixins/activeSessionCheckerMixin';
    import MaterialHeader from '../../../components/UI/MaterialHeader';
    import Locale from '../../../components/UI/Locale';

    const vuexModule = 'Locales';

    export default {

        mixins: [activeSessionChecker],

        components: {
            Json,
            MaterialHeader,
            Locale
        },

        data() {
            return {
                debug: false,
                searchTerm: '',
                activeLocales: [],
            }
        },
        computed: {
            ...mapGetters(vuexModule, [
                'searchLocales'
            ]),
            ...mapState(vuexModule, [
                'locales',
                'localesLoading'
            ]),
            ...mapState('PanelSettings', [
                'settings'
            ]),

            localesList() {
                if (!this.searchTerm) {
                    return this.locales;
                }
                return this.searchLocales(this.searchTerm);
            },

            panelLocalesList() {
                if (!this.settings.locales) return [];
                return this.settings.locales;
            }
        },

        methods: {

            ...mapActions('PanelSettings', [
                'enableLocale',
                'disableLocale',
            ]),

            ...mapActions(vuexModule, [
                'getLocales'
            ]),

            reloadClicked() {
                this.getLocales();
            },

            localeEnabled(locale) {

                this.enableLocale(locale)
                    .then(response => {
                        Bus.$emit('flash-message', {message: 'Locale has been added! Review the help file on this page for what to do next!'});
                    })
                    .catch(error => {
                        if (error.response.status === 409 || error.response.status === 404) {
                            Bus.$emit('flash-message', {message: error.response.data.message, type: 'error'});
                        } else {
                            Bus.$emit('flash-message', {
                                message: 'OOPS! That did not work out. Try reloading and attempting again',
                                type: 'error'
                            });
                        }
                    });
            },

            localeDisabled(locale) {

                if (this.panelLocalesList.length === 1) {
                    Bus.$emit('flash-message', {
                        message: 'OOPS! That did not work out. You cannot remove the last locale in your panel!',
                        type: 'error'
                    });
                    return;
                }

                this.disableLocale(locale)
                    .then(response => {
                        Bus.$emit('flash-message', {message: 'Locale has been removed!'});
                    })
                    .catch(error => {

                        if (error.response.status === 409 || error.response.status === 404) {
                            Bus.$emit('flash-message', {message: error.response.data.message, type: 'error'});
                        } else {
                            Bus.$emit('flash-message', {
                                message: 'OOPS! That did not work out. Try reloading and attempting again',
                                type: 'error'
                            });
                        }

                    });
            },
        },

        created() {
            if (!this.$store.state[vuexModule]) {
                this.$store.registerModule(vuexModule, Store);
            }

            this.getLocales();
        },
    }

</script>
